import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  expiredCodeTime: Date | null;
  temporaryToken: string;
}

const initialState: AuthState = {
  expiredCodeTime: null,
  temporaryToken: '',
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setExpiredCodeTime: (state, action: PayloadAction<Date | null>) => {
      state.expiredCodeTime = action.payload;
    },
    setTemporaryToken: (state, action: PayloadAction<string>) => {
      state.temporaryToken = action.payload;
    },
  },
});

export const { setExpiredCodeTime, setTemporaryToken } = authSlice.actions;

export default authSlice.reducer;
